// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__20FNJ","footer":"ReportModalFilter_footer__2DDgK"};